export const INSTRUCTOR = "INSTRUCTOR";
export const CRUD_1 = "CRUD_1";
export const CRUD_2 = "CRUD_2";
export const OUTLINE = "OUTLINE";
export const UPDATE_COURSE_DATA = "UPDATE_COURSE_DATA";
export const DRAG = "DRAG";
export const FAQS = "FAQS";
export const TOOLS = "TOOLS";
export const NEXTUP = "NEXTUP";
export const EXTERNAL_COURSE = "EXTERNAL_COURSE";
export const ADD_START_DATE = "ADD_START_DATE";
export const SELECT_DATE_TYPE ="SELECT_DATE_TYPE";
export const EVENT="EVENT";
export const TOOLSLIST="TOOLSLIST";
export const OVERVIEW="OVERVIEW";
export const FOURCEUPD="FOURCEUPD";
export const COURSEASSIGNMENT="COURSEASSIGNMENT";